// src/utils/documentMeta.js
/**
 * Sets basic document metadata for SEO
 * @param {string} title - Page title
 * @param {string} description - Meta description
 */
export const setDocumentMeta = (title, description) => {
    document.title = title;
    
    // Find or create meta description tag
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;
  };
  
  /**
   * Sets Open Graph metadata for social sharing
   * @param {Object} options - Open Graph options
   */
  export const setOpenGraphMeta = ({ title, description, image, type, url }) => {
    // Helper to set or create meta tags
    const setMetaTag = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    // Set Open Graph tags
    setMetaTag('og:title', title);
    setMetaTag('og:description', description);
    setMetaTag('og:image', image);
    setMetaTag('og:type', type || 'website');
    setMetaTag('og:url', url);
    
    // Set Twitter Card tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', image);
  };
  
  /**
   * Sets Schema.org structured data
   * @param {Object} schema - Schema.org JSON-LD object
   */
  export const setSchemaData = (schema) => {
    // Remove any existing schema
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    // Add new schema
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  };